function initChatbot() {
  var $form = $('#chatbot-form');
  var $input = $('.chatbot-input-field');
  var $sendBtn = $('.chatbot-send-btn');
  var $thinking = $('.chatbot-thinking');
  var $escalationPanel = $('#chatbot-escalation-panel');

  // Handle form submit
  $form.on('ajax:beforeSend', function() {
    var question = $input.val().trim();
    if (!question) return false;

    $input.prop('disabled', true);
    $sendBtn.prop('disabled', true);
    $thinking.show();
  });

  // Handle enter key — click the Send button so Rails UJS picks up
  // the submit event (calling $form.submit() bypasses UJS in jQuery 3.x
  // and causes a full page reload).
  $input.on('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      $sendBtn.trigger('click');
    }
  });

  // Show escalation panel inside widget
  $(document).on('click', '.chatbot-escalate-btn', function(e) {
    e.preventDefault();
    var questionId = $(this).data('chat-question-id');
    $('#chatbot-escalation-question-id').val(questionId);
    $escalationPanel.slideDown(200);
    $('.chatbot-messages').hide();
    $form.hide();
  });

  // Close escalation panel
  $(document).on('click', '#chatbot-escalation-close, #chatbot-escalation-cancel-btn', function() {
    $escalationPanel.slideUp(200);
    $('.chatbot-messages').show();
    $form.show();
  });
}

export { initChatbot };
